import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.get('/Authenticate/StaffGoogleRefresh-Token', {
            withCredentials: true
        });

        if (response.status === 204) {
            return null;
        }

        const accessToken = response.data.AccessToken || response.data.accessToken;

        setAuth({
            userId: response.data.userId,
            user: response.data.username,
            fullName: response.data.fullName,
            email: response.data.email,
            role: response.data.role,
            accessToken: accessToken,
            universityId: response.data.universityId,
            universityName: response.data.universityName,
            lastSuccessfulLoginDate: response.data.lastSuccessfulLoginDate,

        });
        return accessToken;
    }
    return refresh;
};

export default useRefreshToken;
